import { Toast } from "mint-ui";
import CryptoJS from 'crypto-js/crypto-js'

export default class {
    //验证手机
    CheckPhone(phone) {
        if (!phone) {
            Toast({
                message: "请输入手机号码",
                position: "bottom",
                duration: 1500
            });
            return false;
        
           } else {
        //     var reg = /^1[34578][0-9]{9}$/; //验证规则，
        //     // var reg = /^1[35879]\d{9}$|^(0\d{2,3}-?|\(0\d{2,3}\))?[1-9]\d{4,7}(-\d{1,8})?$/; //验证规则，
        //     if (!reg.test(phone)) {
        //         Toast({
        //             message: "请输入正确的手机号码",
        //             position: "bottom",
        //             duration: 1500
        //         });
        //         return false;
        //     }
            return true;
        }
    }
    //只能是数字
    
    //时间格式转换  1993-11-11
    FormatDate(time, needHour, noNeedYear) {
        if (time) {
            let date = new Date(time);
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let M = date.getMinutes();
            M = M < 10 ? "0" + M : M;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            if (needHour) {
                return y + "-" + m + "-" + d + " " + h + ":" + M + ":" + s;
            }
            if (noNeedYear) {
                if (needHour) {
                    return `${m}-${d} ${h}:${M}:${s}`;
                }
                return `${m}-${d}`;
            }
            return y + "-" + m + "-" + d;
        } else {
            return '';
        }
    }
    FormatDateM(time, needHour, noNeedYear) {
        if (time) {
            let date = new Date(time);
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let M = date.getMinutes();
            M = M < 10 ? "0" + M : M;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            if (needHour) {
                return y + "-" + m + "-" + d + " " + h + ":" + M + ":" + s;
            }
            if (noNeedYear) {
                if (needHour) {
                    return `${m}-${d} ${h}:${M}:${s}`;
                }
                return `${m}-${d}`;
            }
            return y + "-" + m ;
        } else {
            return '';
        }
    }
    //加密
    encryption(data) {
        data.AppId = 'quanmaipeng';
        let strs = [];
        for (let i in data) {
            strs.push(i + '=' + encodeURIComponent(data[i]));
        }
        strs.sort();  // 数组排序
        strs = strs.join(''); // 数组变字符串
        // strs = encodeURIComponent(strs.join('')); // 数组变字符串

        data.Sign = CryptoJS.HmacSHA1(strs, 'Kaj1vyop83')
            .toString().toLocaleUpperCase();
        return data;
    }

    //图片跨域转换
    cacheExternalImage(url) {
        var img = new Image,
            src = url,
            cvs = document.createElement('canvas'),
            ctx = cvs.getContext('2d');
        img.crossOrigin = "Anonymous";
        img.onload = function () {
            //ctx.drawImage( img, 0, 0 );
        }
        img.src = src;
        if (img.complete || img.complete === undefined) {
            img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
            img.src = src;
        }
        return img;
    }

    //拼音排序(对象)
    pySegSort(arr, key) {
        let me = this;
        if (arr.length == 0) return;
        if (!String.prototype.localeCompare) {
            return null;
        }
        var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ#".split('');
        var zh = "阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀".split('');

        var segs = [];
        var curr;
        letters.forEach(function (item, i) {
            curr = { letter: item, data: [] };

            if (i != 26) {
                for (var j = 0; j < arr.length; j++) {
                    if (!arr[j][key]) break;
                    var initial = arr[j][key].charAt(0);//截取第一个字符
                    if (arr[j][key].charAt(0) == letters[i] || arr[j][key].charAt(0) == letters[i].toLowerCase()) {   //首字符是英文的
                        curr.data.push(arr[j]);
                    } else if (zh[i] != '*' && me.isChinese(initial)) {      //判断是否是无汉字,是否是中文
                        if (initial.localeCompare(zh[i], 'zh') >= 0 && (!zh[i + 1] || initial.localeCompare(zh[i + 1], 'zh') < 0)) {   //判断中文字符在哪一个类别
                            curr.data.push(arr[j]);
                        }
                    }
                }
            } else {
                for (var k = 0; k < arr.length; k++) {
                    if (!arr[k][key]) break;
                    var ini = arr[k][key].charAt(0);           //截取第一个字符
                    if (!me.isChar(ini) && !me.isChinese(ini)) {
                        curr.data.push(arr[k]);
                    }
                }
            }
            if (curr.data.length) {
                segs.push(curr);
                //curr.data.sort(function(a,b){
                //    return b.localeCompare(a);       //排序,英文排序,汉字排在英文后面
                //});
            }

            // arr.forEach(function (item2) {
            //     // if (zh[i - 1]) {
            //     //     alert(zh[i - 1].localeCompare(item2[key], 'zh') + '++++++' + item2[key].localeCompare(zh[i], 'zh'))
            //     // }
            //     if ((!zh[i + 1] || zh[i + 1].localeCompare(item2[key], 'zh') < 0) && item2[key].localeCompare(zh[i], 'zh') >= 0) {
            //         debugger
            //         // alert(JSON.stringify(item2))
            //         curr.data.push(item2);
            //     }
            // });
            // if (curr.data.length) {
            //     curr.data.sort(function (a, b) {
            //         return a[key].localeCompare(b[key]);
            //     });
            //     // alert(JSON.stringify(curr))
            //     segs.push(curr);
            // }
        });
        // alert(JSON.stringify(segs))
        return segs;
    }
    isChinese(temp) {
        var re = /[^\u4E00-\u9FA5]/;
        if (re.test(temp)) { return false; }
        return true;
    }
    isChar(char) {
        var reg = /[A-Za-z]/;
        if (!reg.test(char)) { return false; }
        return true;
    }

    /**
     * 判断当前是支付宝还是微信  1-微信
     */
    isAlipayOrWechat() {
        var userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.match(/MicroMessenger/i) == "micromessenger") return 1;
        return 0;
    }

    /**
     * 压缩图片
     */
    FormatImg() {
        // 通过canvas压缩图片
        var reader = new FileReader();
        reader.readAsDataURL(file);
        var img = new Image;
        reader.onload = function (e) {
            var width = 1080, //图像大小
                quality = 0.8, //图像质量
                canvas = document.createElement("canvas"),
                drawer = canvas.getContext("2d");
            img.src = this.result;
            img.onload = function () {
                canvas.width = width;
                canvas.height = width * (img.height / img.width);
                drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
                img.src = canvas.toDataURL("image/png", quality);
                return canvas.toDataURL("image/png", quality);
            }
        }
    }
    //将时间戳转换为时间格式(年月日)
     timestampToTime(timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() < 10 ? '0'+date.getDate() : date.getDate()  + ' ';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();
        return Y+M+D;
    }
//将时间戳转换为时间格式(年月日)
timestampToTimestring(timestamp) {
  var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '.';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '.';
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ' ';
  var h = date.getHours() + ':';
  var m = date.getMinutes() + ':';
  var s = date.getSeconds();
  return Y + M + D;
}
     //将当前时间戳转换为时间格式(年月日)
     LocalTime(timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() < 10 ? '0'+date.getDate() : date.getDate()  + ' ';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();
        return Y+M+D;
    }
    DateMonth(){
        var date = new Date();
        var Y = date.getFullYear() +'';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1)+'';
        var D = date.getDate() < 10 ? '0'+date.getDate() : date.getDate()  + '';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();
        return Y+'年'+M+'月'+D+'日';
    }
     //将时间戳转换为时间格式（年月日时分秒）
     timestampToTime2(timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D =  (date.getDate() < 10 ? '0'+date.getDate() : date.getDate() ) + ' ';
        var h =  (date.getHours() < 10 ? '0'+date.getHours() : date.getHours())+ ':';
        var m =  (date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()) + ':';
        var s = (date.getSeconds()<10?'0'+ date.getSeconds(): date.getSeconds());
        return Y+M+D+h+m+s;
    }
      //将时间戳转换为时间格式（年月日时分秒）
      timestampToTime5(timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D =  (date.getDate() < 10 ? '0'+date.getDate() : date.getDate() ) + ' ';
        var h =  (date.getHours() < 10 ? '0'+date.getHours() : date.getHours())+ ':';
        var m =  (date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()) 
        return Y+M+D+h+m;
    }
    //将时间戳转换为时间格式（年月日时）
    timestampToTime3(timestamp) {
        var date = new Date((timestamp-1) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate() ) + ' ';
        var h = date.getHours();
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();
        return Y+M+D+'24时';
    }
     //将时间戳转换为时间格式（年月日时分秒）
     timestampToTime4(timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D =  (date.getDate() < 10 ? '0'+date.getDate() : date.getDate() ) + ' ';
        var h =  (date.getHours() < 10 ? '0'+date.getHours() : date.getHours())+ ':';
        var m =  (date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes());
        return h+m;
    }
    // base64转文件
    dataURItoBlob(dataURI) {
        var byteString = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    }
    jsonarr(arr1,arr2,arr3){
        for (var i = 0; i < arr1.length; i++) {
        var SubjectsObject = {};
           for (var j = 0; j < arr2.length; j++) {
             if (i == j) {
          SubjectsObject.name = arr1[i];
          SubjectsObject.value = arr2[j];
          arr3.push(SubjectsObject);
         }
        }
       }
      return arr3;
    } 
    //使用时间戳倒计时
    countTime(str) {
      //获取当前时间
      var date = new Date();
      var now = date.getTime();
      //设置截止时间
     // var str="2017/5/17 00:00:00";
      var endDate = new Date(str*1000);
      var end = endDate.getTime();
      //时间差
      var leftTime = end - now;
      //定义变量 d,h,m,s保存倒计时的时间
      var h, m, s;
      if(leftTime>0){
        h = Math.floor((leftTime / 1000 / 60 / 60));
        m = Math.floor((leftTime / 1000 / 60) % 60);
        s = Math.floor((leftTime / 1000) % 60);
        function formatstr(value)
        {
        return (value<10)?"0"+value:value;
        }
        return formatstr(h)+":"+formatstr(m)+":"+formatstr(s)
      }else{
      }
        return '00'+':'+'00'+":"+'00';  
    }
     //使用时间戳倒计时
     countTime2(str) {
        //获取当前时间
        var date = new Date();
        var now = date.getTime();
        //设置截止时间
       // var str="2017/5/17 00:00:00";
        var endDate = new Date(str*1000);
        var end = endDate.getTime();
        //时间差
        var leftTime = end - now;
        //定义变量 d,h,m,s保存倒计时的时间
        var h, m, s;
        if(leftTime>0){
          h = Math.floor((leftTime / 1000 / 60 / 60));
          m = Math.floor((leftTime / 1000 / 60) % 60);
          function formatstr(value)
          {
          return (value<10)?"0"+value:value;
          }
          return formatstr(h)+"小时"+formatstr(m)+"分钟"
        }else{
        }
          return '00'+'小时'+'00'+'分钟';  
      }
//获取某个时间是否在某个时间段
time_range(beginTime, endTime) {
    var strb = beginTime.split (":");
    if (strb.length != 2) {
      return false;
    }
   
    var stre = endTime.split (":");
    if (stre.length != 2) {
      return false;
    }
   
    var b = new Date ();
    var e = new Date ();
    var n = new Date ();
   
    b.setHours (strb[0]);
    b.setMinutes (strb[1]);
    e.setHours (stre[0]);
    e.setMinutes (stre[1]);
   
    if (n.getTime () - b.getTime () > 0 && n.getTime () - e.getTime () < 0) {
      return true;
    } else {
     // alert ("当前时间是：" + n.getHours () + ":" + n.getMinutes () + "，不在该时间范围内！");
      return false;
    }
  }
  //获取当前周几是否在工作时间
  week_range(beginTime,endTime){
    var b = new Date().getDay();
   if(beginTime<=b&&b<=endTime){
       return true;
   }else{
       return false
   }
  }
    /**
   * 获取当前月的第一天
   */
 getMonthFirst(){
    var month=new Date().getMonth()+1 
    var nowDays = new Date();  
    var year = nowDays.getFullYear();  
   if (month < 10) {  
      month = "0" + month;  
     }  
    var firstDay = year+'-' + month+'-'+ "01";
      return  firstDay
    }
    /**
*判断是否是数字
**/
isRealNum(val){
    // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除
    if(val === "" || val ==null){
        return false;
    }
    if(!isNaN(val)){
        return true;
    }else{
        return false;
    }
}
  //将当前时间转化为年月日
  getNowFormatDate() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
}
}


// WEBPACK FOOTER //
// ./src/util/base.js